module.exports = __webpack_public_path__ + "img/mural-mensagens.01bd5a72.jpg";